/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import isNumber from "lodash/isNumber";
import isEmpty from "lodash/isEmpty";
import Accordion from "./Accordion";
import MaterialOpacityInteraction from "./MaterialOpacityInteraction";
import SelectDropdown from "./SelectDropdown";

const Opacity = ({
  getMaterialNames,
  applyOpacity,
  currentConfig = {},
  updateConfig,
}) => {
  console.log("Opacity Component render", currentConfig);
  const [materials, setMaterials] = useState([...Object.keys(currentConfig)]);

  useEffect(() => {
    if (!isEmpty(currentConfig)) {
      setMaterials([...Object.keys(currentConfig)]);
    }
  }, [setMaterials, currentConfig]);

  const addOpacity = (materialName) => {
    currentConfig[materialName] = {
      opacity: 1,
      visible: true,
      transparent: false,
    };
    setMaterials(currentConfig ? [...Object.keys(currentConfig)] : []);
    updateConfig(currentConfig);
  };

  const removeMaterial = (materialName) => {
    return () => {
      delete currentConfig[materialName];
      setMaterials(currentConfig ? [...Object.keys(currentConfig)] : []);
      updateConfig({ ...currentConfig }, true);
    };
  };

  const getRemainingMaterials = () => {
    const allMaterials = getMaterialNames();
    return allMaterials.filter((e) => !materials.includes(e));
  };

  const OpacityPanel = () => {
    return (
      <div className="opacity-panel-container">
        <div className="opacityInteractionContainer">
          {materials.map((material) => {
            console.log(material, currentConfig[material]);
            return (
              <MaterialOpacityInteraction
                key={material}
                materialName={material}
                opacityValue={
                  isNumber(currentConfig[material]?.opacity)
                    ? currentConfig[material]?.opacity
                    : 1
                }
                removeMaterial={removeMaterial(material)}
                applyOpacity={(config) => {
                  applyOpacity(material, config);
                  currentConfig[material] = config;
                }}
                updateConfig={() => {
                  updateConfig(currentConfig);
                }}
              />
            );
          })}
        </div>
        <div className="materialActions">
          <SelectDropdown
            placeholder="Select Material"
            menuList={getRemainingMaterials()}
            onMenuSelect={addOpacity}
          />
        </div>
      </div>
    );
  };
  return (
    <div className="opacityContainer">
      <Accordion
        accordion
        className="opacity-accordion"
        panelList={[
          {
            header: "Opacity",
            headerClass: "opacity-accordion-header",
            component: <OpacityPanel />,
          },
        ]}
      />
    </div>
  );
};

export default Opacity;
